import { TaskView } from '@/modules/tasks/models/TaskViewBody'

import { axios } from '../index'

const viewTaskUser = (body: TaskView) => {
  return axios.post('/v1/tasks/view', body)
}

export default viewTaskUser
